import { Fragment, h } from 'preact';
import style from "./minicartButton.module.css";
import { useMinicartButton } from "./useMinicartButton";
import { useAppContext, useBehavioralContext } from '../../../../contexts';
import NewItemAlert from "./NewItemAlert";

const MinicartButton = () => {
    // Retrieves the method to trigger the cart from the behavioral context
    const { handleCart } = useBehavioralContext();

    // Component logic data
    const componentProps = useMinicartButton();

    // Destructured component logic data
    const {
        currentIconState,
        qtyItems,
        standardImageRef,
        buttonIconHelper,
    } = componentProps;

    const {
        accessibilityFont,
        highContrast
    } = useAppContext();

    let buttonIcon = (
        <img
            ref={standardImageRef}
            src={`${buttonIconHelper(currentIconState["icon"])}`}
            alt={"Cart icon"}
            className={`${style["default-icon"]} ${style.bagIcon} ${highContrast ? "filter grayscale" : ""}`}
            data-testid="minicart-icon"
        />
    );

    // The number of items that's in the user's cart
    const itemsAmount = (
        <div className={`
            ${style.itemsCounterContainer} 
            ${style.qtyFadeAnimation} 
            ${highContrast ? "grayBackground hover:!bg-black" : ""}
        `}>
            <p data-testid="minicart-count">
                {qtyItems}
            </p>
        </div>
    );

    return (
        <div className={"font-museo select-none h-full flex z-0 -mt-[1px]"} key={qtyItems}>
            <button
                type={"button"}
                id={"minicart-button"} // Be careful not to change this value.
                className={`
                    ${style.cartButton} dark:bg-[#575757] 
                    ${highContrast ? "hover:!bg-[#242424]" : ""}
                `}
                style={{
                    fontSize: `${10 + accessibilityFont}px`
                }}
                data-testid="minicart-button"
                onClick={() => handleCart("isOpen", true)}
            >
                <div className={style.bagIconContainer}>
                    {buttonIcon}
                </div>
                <p className={style.cartButtonLabel} data-testid="minicart-label">
                    Minhas Compras
                </p>
                <p className={style.mobileCartButtonLabel} data-testid="minicart-label">
                    Compras
                </p>
                {itemsAmount}
            </button>
            <NewItemAlert />
        </div>
    )
}

export default MinicartButton;
